<template>
  <div class="limited-access-badge d-flex align-items-center gap-2">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="badge-icon flex-shrink-0">
      <g clip-path="url(#clip0_18753_50002)">
        <circle cx="12" cy="11.8013" r="10.3" fill="white"/>
        <path d="M12 1.47517C14.7848 1.47517 17.4555 2.5631 19.4246 4.49963C21.3938 6.43616 22.5 9.06266 22.5 11.8013C22.5 14.54 21.3938 17.1665 19.4246 19.103C17.4555 21.0395 14.7848 22.1275 12 22.1275C9.21523 22.1275 6.54451 21.0395 4.57538 19.103C2.60625 17.1665 1.5 14.54 1.5 11.8013C1.5 9.06265 2.60625 6.43616 4.57538 4.49963C6.54451 2.5631 9.21523 1.47517 12 1.47517ZM12 1.0317e-06C8.81741 7.5808e-07 5.76516 1.24335 3.51472 3.45653C1.26429 5.6697 3.23465e-06 8.67142 2.95642e-06 11.8013C2.67819e-06 14.9312 1.26428 17.9329 3.51472 20.1461C5.76516 22.3593 8.8174 23.6026 12 23.6026C15.1826 23.6026 18.2348 22.3593 20.4853 20.1461C22.7357 17.9329 24 14.9312 24 11.8013C24 8.67142 22.7357 5.66971 20.4853 3.45653C18.2348 1.24335 15.1826 1.30533e-06 12 1.0317e-06Z" fill="#212529"/>
        <path d="M10.605 13.8843L14.04 13.4609L14.163 12.9003L13.488 12.7779C13.047 12.6746 12.96 12.5183 13.056 12.086L14.163 6.97016C14.454 5.64693 14.0055 5.02441 12.951 5.02441C12.1335 5.02441 11.184 5.39616 10.7535 5.90656L10.6215 6.52023C10.9215 6.2606 11.3595 6.15734 11.6505 6.15734C12.063 6.15734 12.213 6.44205 12.1065 6.9436L10.605 13.8843ZM10.5 16.9644C10.5 16.5732 10.658 16.1979 10.9393 15.9213C11.2206 15.6447 11.6022 15.4892 12 15.4892C12.3978 15.4892 12.7794 15.6447 13.0607 15.9213C13.342 16.1979 13.5 16.5732 13.5 16.9644C13.5 17.3556 13.342 17.7309 13.0607 18.0075C12.7794 18.2841 12.3978 18.4396 12 18.4396C11.6022 18.4396 11.2206 18.2841 10.9393 18.0075C10.658 17.7309 10.5 17.3556 10.5 16.9644Z" fill="#212529"/>
      </g>
      <defs>
        <clipPath id="clip0_18753_50002">
          <rect width="24" height="23.6026" fill="white" transform="translate(24 23.6026) rotate(-180)"/>
        </clipPath>
      </defs>
    </svg>

    <span class="badge-message">{{ message }}</span>

    <a
      class="badge-learn-more hand-cursor text-decoration-none text-14 text-primary ms-1"
      href="#"
      @click.prevent="$emit('learnMoreClick')"
    >
      <strong>Learn More</strong>
      <i class="bi bi-chevron-right ms-2"></i>
    </a>
  </div>
</template>

<script>
export default {
  name: 'LimitedAccessBadge',
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  emits: ['learnMoreClick']
}
</script>

<style scoped>
.limited-access-badge {
  width: 100%;
  height: 60px;
  padding: 0 9%;
  background: var(--Yellow-100, #FFF3CD);
}

.badge-icon {
  width: 24px;
  height: 23.603px;
}

.badge-message {
  color: var(--Body-Color, #212529);
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%;
  letter-spacing: -0.28px;
}
</style>
